module.exports = __webpack_public_path__ + "static/Signature-132f064320fea9f538a6f5ff2c452eb6.svg";